import tableState  from "./states/table"
import detailState from "./states/detail"
import formState  from "./states/form"

const state = () => ({table: {...tableState}, detail: {...detailState}, form: {...formState} })

export default state


